// maybe add check for dev and change accordingly e.g. process.env.NODE_ENV === "development"
export const defaultConfig = {
	baseApiUrl: 'https://c2022.ewo.com',
};

export const configUrl = '/config.json';